<template>
  <div class="content-menu is-hidden-mobile" :class="{ open: open }">
    <button
      class="button button-menu is-link"
      :class="{ 'is-hidden': open }"
      v-on:click="open = !open"
    >
      <i class="material-icons">info</i>
    </button>
    <div class="minimal-panel">
      <!-- Header limpio -->
      <div ref="menuInter" class="panel-header">
        <div class="header-content">
          <h2 class="panel-title">Definiciones</h2>
          <div class="breadcrumb" v-if="currentSubtitle">
            <span class="breadcrumb-item">{{ currentSubtitle }}</span>
          </div>
        </div>

        <button
          class="nav-button"
          @click="goBack"
          v-if="currentView !== 'main'"
        >
          <i class="material-icons">subdirectory_arrow_left</i>
        </button>
        <button class="nav-button" @click="togglePanel" v-else>
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Vista principal -->
      <div ref="menuInter" class="panel-content" v-if="currentView === 'main'">
        <div class="categories-container">
          <div
            v-for="(inter, index) in Object.values(interpretation)"
            :key="index"
            class="category-item"
            @click="selectInterpretation(inter, index)"
          >
            <div class="category-content">
              <div class="category-icon">
                <i class="material-icons">{{
                  namesVar.iconsInterpretation[index]
                }}</i>
              </div>
              <div class="category-info">
                <h3 class="category-name">{{ inter.title }}</h3>
                <span class="items-count">
                  {{ getCountItems(inter.dimensiones) }}
                </span>
              </div>
            </div>
            <div class="category-arrow">
              <i class="material-icons">arrow_forward</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista de categoría con información general automática -->
      <div
        ref="menuInter"
        class="panel-content"
        v-else-if="currentView === 'category'"
      >
        <div class="category-detail">
          <!-- Información general automática -->
          <div class="general-info-section">
            <div class="info-header">
              <div class="info-icon">
                <i class="material-icons">{{
                  namesVar.iconsInterpretation[selectedInterpretation.index]
                }}</i>
              </div>
              <h3 class="info-title">Información General</h3>
            </div>

            <div class="info-content" v-if="selectedInterpretation.def">
              <div class="info-item">
                <div class="info-label">
                  <i class="material-icons">import_contacts</i>
                  <span>Definición</span>
                </div>
                <p class="info-text">{{ selectedInterpretation.def }}</p>
              </div>

              <div class="info-item" v-if="selectedInterpretation.inter">
                <div class="info-label">
                  <i class="material-icons">lightbulb_outline</i>
                  <span>Interpretación</span>
                </div>
                <p class="info-text">
                  {{ selectedInterpretation.inter }}
                </p>
              </div>
            </div>
          </div>

          <!-- Rangos del item principal
          <div v-if="getSize(selectedInterpretation.rango)">
            <div class="section-header">
              <h4 class="section-title">Rangos</h4>
              <span class="section-count">{{
                getSize(selectedInterpretation.rango)
              }}</span>
            </div>

            <div class="ranks-container">
              <div
                v-for="(rank, index) in Object.values(
                  selectedInterpretation.rango
                )"
                :key="`rankInter-${index}`"
                @click="selectRank(rank, index)"
              >
                <div v-if="index" class="rank-item">
                  <div :class="`rank-badge rank-${index}`">{{ index }}</div>
                  <div class="rank-content">
                    <h5 class="rank-title">{{ rank.title }}</h5>
                    <p class="rank-desc">{{ namesVar.ranges[index] }}</p>
                  </div>
                  <i class="material-icons subitem-arrow">arrow_forward</i>
                </div>
              </div>
            </div>
          </div> -->

          <!-- SubItems principales -->
          <div v-if="getSize(selectedInterpretation.dimensiones)">
            <div class="section-header">
              <h4 class="section-title">Elementos</h4>
              <span class="section-count">{{
                getSize(selectedInterpretation.dimensiones)
              }}</span>
            </div>

            <div class="subitems-container">
              <div
                v-for="(subItem, index) in selectedInterpretation.dimensiones"
                :key="`subItem-${index}`"
                class="subitem-card"
                @click="selectSubItem(subItem)"
              >
                <div class="subitem-header">
                  <h5 class="subitem-title">{{ subItem.title }}</h5>
                  <i class="material-icons subitem-arrow">arrow_forward</i>
                </div>
                <!-- <p class="subitem-desc">{{ subItem.shortDesc || "-" }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista de subitem con toda su información -->
      <div
        ref="menuInter"
        class="panel-content"
        v-else-if="currentView === 'subitem'"
      >
        <div class="subitem-detail">
          <!-- Header del subitem -->
          <div class="subitem-detail-header">
            <h3 class="subitem-detail-title">{{ selectedSubItem.title }}</h3>
          </div>

          <!-- Información básica del subitem -->
          <div class="subitem-info-section" v-if="selectedSubItem.def">
            <div class="info-item">
              <div class="info-label">
                <i class="material-icons">import_contacts</i>
                <span>Definición</span>
              </div>
              <p class="info-text">{{ selectedSubItem.def }}</p>
            </div>

            <div class="info-item" v-if="selectedSubItem.inter">
              <div class="info-label">
                <i class="material-icons">lightbulb_outline</i>
                <span>Interpretación</span>
              </div>
              <p class="info-text">{{ selectedSubItem.inter }}</p>
            </div>

            <div
              class="info-item improvements-item"
              v-if="selectedSubItem.pract"
            >
              <div class="info-label">
                <i class="material-icons">rocket_launch</i>
                <span>Buenas Prácticas</span>
              </div>
              <div class="improvements-text">{{ selectedSubItem.pract }}</div>
            </div>
          </div>

          <!-- Rangos del subitem
          <div v-if="getSize(selectedSubItem.rango)">
            <div class="section-header">
              <h4 class="section-title">Rangos</h4>
              <span class="section-count">{{
                getSize(selectedSubItem.rango)
              }}</span>
            </div>

            <div class="ranks-container">
              <div
                v-for="(rank, index) in Object.values(selectedSubItem.rango)"
                :key="`rank-${index}`"
                @click="selectRank(rank, index)"
              >
                <div v-if="index" class="rank-item">
                  <div :class="`rank-badge rank-${index}`">{{ index }}</div>
                  <div class="rank-content">
                    <h5 class="rank-title">{{ rank.title }}</h5>
                    <p class="rank-desc">{{ namesVar.ranges[index] }}</p>
                  </div>
                  <i class="material-icons subitem-arrow">arrow_forward</i>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- Vista de detalle de rango
      <div
        ref="menuInter"
        class="panel-content"
        v-else-if="currentView === 'rank'"
      >
        <div class="rank-detail">
          <div class="rank-detail-header">
            <div :class="`rank-detail-icon rank-${selectedRank.index}`">
              <i class="material-icons">{{
                namesVar.iconsRange[selectedRank.index]
              }}</i>
            </div>
            <h3 class="rank-detail-title">{{ selectedRank.title }}</h3>
          </div>

          <div class="rank-detail-content">
            <div class="detail-section">
              <div class="section-label">
                <i class="material-icons">lightbulb_outline</i>
                <span>Interpretación</span>
              </div>
              <p class="section-text">{{ selectedRank.inter }}</p>
            </div>

            <div class="detail-section">
              <div class="section-label">
                <i class="material-icons">flag</i>
                <span>Meta</span>
              </div>
              <p class="section-text">{{ selectedRank.meta }}</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import json from "./interpretaciones.json";

export default {
  name: "MenuInterpretations",
  data() {
    return {
      open: false,
      currentView: "main",
      selectedInterpretation: null,
      selectedSubItem: null,
      selectedRank: null,
      currentSubtitle: "",
      interpretation: json,
      namesVar: {
        ranges: [
          "Sin rango", // 0
          "Sigamos así", // 1
          "Vamos bien", // 2
          "Cuidado", // 3
          "Necesita atención pronto", // 4
          "Actuemos ya", // 5
        ],
        iconsRange: [
          "do_disturb_on", // Sin rango
          "sentiment_very_satisfied", // Sigamos así
          "sentiment_satisfied", // Vamos bien
          "sentiment_neutral", // Cuidado",
          "sentiment_very_dissatisfied", // Necesita atención pronto
          "mood_bad", // Actuemos ya
        ],
        iconsInterpretation: [
          "wb_sunny", // climalab
          "volunteer_activism", // apoyod
          "verified", // calidadd
          "lightbulb", // innovaciond
          "flag", // metasd
          "widgets", // dimenc
        ],
      },
    };
  },
  beforeMount() {
    // console.log("Data", json);
  },
  methods: {
    selectInterpretation(item, index) {
      this.selectedInterpretation = { ...item, index };
      this.currentView = "category";
      this.currentSubtitle = item.title;
      this.resetScroll();
    },

    selectSubItem(subItem) {
      this.selectedSubItem = subItem;
      this.currentView = "subitem";
      this.currentSubtitle += ` / ${subItem.title}`;
      this.resetScroll();
    },

    selectRank(rank, index) {
      this.selectedRank = {
        ...rank,
        index,
        title: this.namesVar.ranges[index],
      };
      this.currentView = "rank";
      this.resetScroll();
    },

    goBack() {
      if (this.currentView === "rank") {
        this.currentView = "subitem";
      } else if (this.currentView === "subitem") {
        this.currentView = "category";
        this.currentSubtitle = this.currentSubtitle.split(" / ")[0];
      } else if (this.currentView === "category") {
        this.currentView = "main";
        this.currentSubtitle = "";
        this.selectedInterpretation = null;
      }
      this.resetScroll();
    },

    getCountItems(items) {
      if (!items) return `-`;
      const size = Object.keys(items).length;
      if (size) return `${size} elementos`;
      if (!size) return `-`;
    },

    getSize(items) {
      if (!items) return 0;
      let size = 0;

      if (Array.isArray(items)) size = items.length;
      if (typeof items === "object") size = Object.keys(items).length;

      return size;
    },

    resetScroll() {
      this.$refs.menuInter.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    togglePanel() {
      this.open = false;
    },
  },
};
</script>

<style scoped>
.content-menu {
  top: 0;
  right: -360px;
  display: flex;
  position: fixed;
  transition: right 0.3s ease;
  z-index: 60;
}

.button-menu {
  top: 23px;
  width: 60px;
  padding-right: 20px;
  right: -10px;
}

.open {
  right: 0 !important;
}

.minimal-panel {
  width: 360px;
  height: 100vh;
  background: #ffffff;
  border-left: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.panel-header {
  padding: 20px 16px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fafafa;
}

.nav-button {
  width: 40px;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.nav-button:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.header-content {
  flex: 1;
}

.panel-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #111827;
  line-height: 1.2;
}

.breadcrumb {
  margin-top: 4px;
}

.breadcrumb-item {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.categories-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item {
  padding: 16px;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.category-item:hover {
  border-color: #e5e7eb;
  background: #f9fafb;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.category-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.category-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 16px;
}

.category-info {
  flex: 1;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 2px 0;
  color: #111827;
}

.items-count {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.category-arrow {
  color: #9ca3af;
  font-size: 14px;
  transition: all 0.2s ease;
}

.category-item:hover .category-arrow {
  color: #6b7280;
  transform: translateX(2px);
}

.category-detail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.general-info-section {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 16px;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.info-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #522687;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

.info-icon .material-icons {
  font-size: 20px !important;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label i {
  color: #522687;
  font-size: 14px;
  width: 16px;
}

.info-label span {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.info-text {
  text-align: justify;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  margin: 0;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.section-count {
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
}

.subitems-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subitem-card {
  padding: 16px;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
}

.subitem-card:hover {
  border-color: #e5e7eb;
  background: #f9fafb;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.subitem-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.subitem-title {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.elements-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #e0f2fe;
  border-radius: 8px;
}

.badge-number {
  font-size: 11px;
  font-weight: 700;
  color: #0369a1;
}

.badge-text {
  font-size: 10px;
  font-weight: 500;
  color: #0369a1;
}

.subitem-desc {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.subitem-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.improvement-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #10b981;
}

.subitem-arrow {
  color: #9ca3af;
  font-size: 12px;
  transition: all 0.2s ease;
}

.subitem-card:hover .subitem-arrow {
  color: #6b7280;
  transform: translateX(2px);
}

.subitem-detail {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.subitem-detail-header {
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
}

.subitem-detail-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.subitem-info-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.improvements-item {
  background: #f0fdf4;
  border: 1px solid #dcfce7;
  border-radius: 10px;
  padding: 16px;
}

.improvements-text {
  white-space: pre-wrap;
  text-align: justify;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  margin: 0;
}

.ranks-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rank-item {
  padding: 14px;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
}

.rank-item:hover {
  border-color: #e5e7eb;
  background: #f9fafb;
}

.rank-badge {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #522687;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.rank-content {
  flex: 1;
}

.rank-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 2px 0;
  color: #111827;
}

.rank-desc {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.rank-detail {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rank-detail-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
}

.rank-detail-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: #522687;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.rank-detail-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.rank-detail-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-section {
  padding: 16px;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  background: #ffffff;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.section-label i {
  color: #522687;
  font-size: 14px;
  width: 16px;
}

.section-label span {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.section-text {
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  margin: 0;
}

/* Ranges */
.rank-1 {
  background-color: var(--clima-1) !important;
  color: white;
}

.rank-2 {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rank-3 {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rank-4 {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rank-5 {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rank-0 {
  background-color: rgba(175, 174, 174, 0.8);
}

/* Scrollbar limpio */
.panel-content::-webkit-scrollbar {
  width: 6px;
}

.panel-content::-webkit-scrollbar-track {
  background: #f9fafb;
}

.panel-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.panel-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/MenuInterpretations.vue